import { render } from "./expenses-modal.vue?vue&type=template&id=fe82aa3e"
import script from "./expenses-modal.vue?vue&type=script&lang=js"
export * from "./expenses-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__